import React from 'react';
import css from './metricCardsEmptyStateInner.css';
import Label from '../components/foundations/Label';
import EmptyNumerIcon from '../resources/svg/number_empty.svg';
import metricCardCss from './metricCard.css';

function MetricCardsEmptyStateInner() {
    return (
        <div className={metricCardCss.animatedMetricCard}>
            <div className={css.noData}>
                <EmptyNumerIcon className={css.noDataIcon} />
                <Label className={css.noDataLabel} text="STATIC.PAGES.QUICK_REPORTS.METRIC_CARDS.NO_DATA" />
            </div>
        </div>
    );
}

export default MetricCardsEmptyStateInner;
